import React, { useEffect, useRef } from 'react';

import styles from './RichTextEditor.module.css'

interface RichTextEditorProps {
  value: string;
  onChange: (html: string) => void;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({ value, onChange }) => {
  const editorRef = useRef<HTMLDivElement>(null);

  const format = (command: string, value: string = '') => {
    document.execCommand(command, false, value);
    handleInput(); // sync change
  };

  const handleInput = () => {
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value;
    }
  }, [value]);

  const predefinedColors = [
    { name: 'Black', value: '#000000' },
    { name: 'Red', value: '#ff0000' },
    { name: 'Green', value: '#008000' },
    { name: 'Blue', value: '#0000ff' },
    { name: 'Orange', value: '#ffa500' },
    { name: 'Purple', value: '#800080' },
  ];

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-2">
        {/* Headings */}
        <select onChange={(e) => format('formatBlock', e.target.value)} className={`border px-2 py-1 ${styles['fixed-height']}`}>
          <option value="">Normal</option>
          <option value="h1">H1</option>
          <option value="h2">H2</option>
          <option value="h3">H3</option>
        </select>

        {/* Bold / Italic */}
        <button type="button" onClick={() => format('bold')} className={`border px-2 py-1 ${styles['fixed-height']}`}>Bold</button>
        <button type="button" onClick={() => format('italic')} className={`border px-2 py-1 ${styles['fixed-height']}`}>Italic</button>

        {/* Predefined Colors */}
        <select onChange={(e) => format('foreColor', e.target.value)} className={`border px-2 py-1 ${styles['fixed-height']}`}>
          <option value="">Text Color</option>
          {predefinedColors.map((color) => (
            <option key={color.value} value={color.value}>
              {color.name}
            </option>
          ))}
        </select>

        {/* Lists */}
        <button type="button" onClick={() => format('insertUnorderedList')} className={`border px-2 py-1 ${styles['fixed-height']}`}>Bullet List</button>
        <button type="button" onClick={() => format('insertOrderedList')} className={`border px-2 py-1 ${styles['fixed-height']}`}>Numbered List</button>
      </div>

      <div
        ref={editorRef}
        contentEditable
        className="min-h-[200px] border p-3 rounded bg-white"
        style={{ outline: 'none' }}
        suppressContentEditableWarning={true}
        onInput={handleInput}
      />
    </div>
  );
};

export default RichTextEditor;
